import { render } from "./Mensaje.vue?vue&type=template&id=5748766c"
import script from "./Mensaje.vue?vue&type=script&lang=js"
export * from "./Mensaje.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__